import createCachedSelector from "re-reselect";

const emptyArray = [];
const defaultEligibilities = {
  isLoaded: false
};

export const getOfferEligibilities = (state, partnerId) => {
  const partnerEligibilityData = state.entities.offerPartnerEligibilities[partnerId];
  return partnerEligibilityData ? partnerEligibilityData.partnerEligibility : emptyArray;
};
const getEligibilityData = (state, partnerId) =>
  state.currentOffer.partnerEligibilityData.partnerEligibility[partnerId] || defaultEligibilities;

export const getEligibilitiesIsLoaded = createCachedSelector(getEligibilityData, eligibilities => {
  return eligibilities.isLoaded;
})((_, partnerId) => partnerId);

export const getOfferPartnerEligibilities = createCachedSelector(
  getEligibilitiesIsLoaded,
  getOfferEligibilities,
  (isLoaded, eligibilites) => {
    if (!isLoaded) {
      return emptyArray;
    }
    return eligibilites;
  }
)((_, partnerId) => partnerId);
